<mat-form-field [formGroup]="formGroup" appearance="outline">
  <input
    matInput
    [formControlName]="controlName"
    [matAutocomplete]="auto"
    [placeholder]="placeholder | locale"
    [ngClass]="{ disabled: control.disabled }"
  />
  <mat-autocomplete
    class="custom-panel"
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="optionSelected.emit($event.option.value)"
  >
    @for (item of items; track item) {
      <mat-option [value]="item">
        <span class="autocomplete-option" [class.multiline]="multilineOptions">{{ displayFn(item) }}</span>
      </mat-option>
    }
  </mat-autocomplete>

  @if (displaySearchIcon) {
    <mat-icon matPrefix svgIcon="search" [ngClass]="{ disabled: control.disabled }"> </mat-icon>
  }

  @if (!displaySearchIcon && showDropdownIcon) {
    <mat-icon matSuffix svgIcon="arrow-down"> </mat-icon>
  }
  <mat-error>{{ controlName | errorMessage: formGroup }}</mat-error>
</mat-form-field>
